import DateTime from "../../vendor/luxon/src/datetime.js";
import "../../vendor/luxon/src/duration.js";
import { useMemo } from "react";
const getCalendarChunkType = (index, chunksAmount) => {
  let type = "single";
  switch (chunksAmount) {
    case 2:
      type = index === 0 ? "left" : "right";
      break;
    case 3:
      type = index === 0 ? "left" : index === 1 ? "middle" : "right";
      break;
  }
  return type;
}, useDateSelector = (date, monthCount) => useMemo(() => {
  const luxonDate = date ? DateTime.fromISO(date) : DateTime.now(), months = [];
  for (let i = 0; i < monthCount; i++)
    months.push({
      monthDate: luxonDate.plus({ month: i }).toISODate(),
      type: getCalendarChunkType(i, monthCount)
    });
  return months;
}, [date, monthCount]);
export {
  getCalendarChunkType,
  useDateSelector
};
//# sourceMappingURL=useDateSelector.js.map
